import { useOrg } from '@/features/team/OrgProvider';
import { EncabezadoPantalla } from '@/ui/Sistema';
import { ServicesCard } from './ServicesCard';

/**
 * Honorarios, con pantalla propia.
 *
 * Antes vivía dentro de Configuración, y para llegar al tarifario había que
 * recorrer precios, movilidad, equipo y migración. El tarifario no es una
 * preferencia que se toca una vez: se consulta y se ajusta seguido, así que
 * estar enterrado costaba scroll todos los días.
 */
export function HonorariosPage({ onVolver }: { onVolver: () => void }) {
  const { activeOrg } = useOrg();
  const orgId = activeOrg?.organization_id;
  if (!orgId) return null;

  return (
    <div className="flex flex-col gap-4 p-4" data-testid="honorarios-page">
      <EncabezadoPantalla
        titulo="Honorarios"
        nota="El tarifario: qué se cobra por cada trabajo"
        onVolver={onVolver}
      />
      <ServicesCard organizationId={orgId} isAdmin={activeOrg.is_admin ?? false} />
    </div>
  );
}
